var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-dialog", {
    attrs: {
      title: _vm.title,
      visible: _vm.dialogVisible,
      width: "40%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c("el-form", {
    ref: "form",
    attrs: {
      "status-icon": "",
      model: _vm.form,
      rules: _vm.rules,
      "label-width": "80px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "资源信息",
      prop: "info"
    }
  }, [_c("el-input", {
    staticClass: "inputText",
    attrs: {
      disabled: _vm.disabled,
      type: "textarea",
      rows: 10,
      autocomplete: "off"
    },
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.save();
      }
    },
    model: {
      value: _vm.form.info,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "info", $$v);
      },
      expression: "form.info"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "附图"
    }
  }, [_c("div", {
    staticClass: "image-preview-container"
  }, _vm._l(_vm.form.images, function (image, index) {
    return _c("div", {
      key: index,
      staticClass: "image-preview-item"
    }, [_c("el-image", {
      staticClass: "preview-image",
      staticStyle: {
        width: "150px"
      },
      attrs: {
        src: image.url,
        fit: "cover"
      }
    }), _c("div", {
      staticClass: "image-actions"
    }, [_c("el-button", {
      attrs: {
        type: "danger",
        icon: "el-icon-delete",
        circle: "",
        size: "mini",
        disabled: _vm.disabled
      },
      on: {
        click: function click($event) {
          return _vm.removeImage(index);
        }
      }
    })], 1)], 1);
  }), 0)])], 1), _c("div", {
    staticClass: "bottomDiv"
  }, [_c("el-button", {
    on: {
      click: _vm.handleClose
    }
  }, [_vm._v("关闭")]), _c("el-button", {
    attrs: {
      disabled: _vm.disabled,
      type: "primary"
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v("保存")])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };